import {
  Box,
  Table,
  Tag,
  Text,
  
} from '@chakra-ui/react';
import { ARRIVAL_RATES_FREQUENCIES } from "../../../store/constants";
import ArrivalHeatmap from "../../ArrivalHeatmap";
import { formatNumber } from "../../../store/helpers";
import LineGraph from "../../LineGraph";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  sortReportRows,
} from "../../../store/renderConfig";

const ARRIVAL_RATES_PER_SERVICE_CHART_HEIGHT = "220px";
const formatDecimal = (value) => Number(value || 0).toFixed(2);

export const renderBranchArrivalRatesPerServiceCell = (serviceData, columnId) => {
  if (columnId === "serviceName") return serviceData.serviceName;
  if (columnId === "total") return formatNumber(serviceData.total);
  if (columnId === "percentage") return `${Number(serviceData.totalPct || 0).toFixed(2)}%`;
  if (columnId === "average") return formatDecimal(serviceData.average);
  if (columnId === "min") return formatNumber(serviceData.min);
  if (columnId === "max") return formatNumber(serviceData.max);
  return null;
};

const BranchServicesTable = ({
  data,
  frequency,
  index,
  branchName,
  reportIndex,
  branchIndex,
  renderConfig,
}) => {
  const { serviceName, total, arrivalTimes, chart } = data;

  const heatMapTitle = serviceName + " Time of Day Chart";

  const title = `${reportIndex || ""}.${branchIndex + 1}.${
    index + 1
  }. ${serviceName}`;
  if (!renderConfig?.charts?.enabled) {
    const rows = sortReportRows([data], renderConfig, {
      columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
    });
    const visibleColumns = ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS.filter((column) =>
      renderConfig.columns.includes(column.id)
    );
    return (
      <Box className={`reportTableContainer arrivalRatesPerServiceBlock reportDataTable--${renderConfig.density}`}>
        <Table.Root className={`stripedTable reportDataTable reportDataTable--${renderConfig.density}`} size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              {visibleColumns.map((column) => (
                <Table.ColumnHeader key={column.id}>{column.label}</Table.ColumnHeader>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rows.map((row, rowIndex) => (
              <Table.Row key={`${row.serviceName}-${rowIndex}`}>
                <Table.Cell>{rowIndex + 1}</Table.Cell>
                {visibleColumns.map((column) => (
                  <Table.Cell key={column.id}>
                    {renderBranchArrivalRatesPerServiceCell(row, column.id)}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Box>
    );
  }

  return (
    <>
      <Box className="reportContainer arrivalRatesPerServiceChartBlock" mt="20px">
        <h3>{title}</h3>
        <Tag.Root>
          <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
        </Tag.Root>
        {!total && (
          <Text fontSize="sm">No data available for this report</Text>
        )}

        {total ? (
          <Box mt="16px" mb="20px">
            <LineGraph
              chart={chart}
              height={ARRIVAL_RATES_PER_SERVICE_CHART_HEIGHT}
              title={`${serviceName} Arrival Rates, Day by Day Comparison`}
            />
            {frequency === ARRIVAL_RATES_FREQUENCIES.HOUR ? (
              <ArrivalHeatmap
                title={heatMapTitle}
                arrivalTimes={arrivalTimes}
                businessHoursSchedule={data.businessHoursSchedule}
              />
            ) : (
              <></>
            )}
          </Box>
        ) : null}
      </Box>
    </>
  );
};

export default BranchServicesTable;
